/* app/ui/map/map.operator */

define(
	'app/ui/map/map.operator',[
		'jquery',
		'pubsub'
	],
	function ($) {

		window.dataLayer = window.dataLayer || [];

		var Module;

		var $maps;
		var feedData = {};
		var queryObj = {};

		return {
			init: function ($elms) {
				Module = this;
				$maps = $elms;

				for (var i = 0; i < $maps.length; i++) {
					var baseJsonUrl = $maps.eq(i).data('json-url');

					if (baseJsonUrl !== '') {
						Module._fetchFeedData(baseJsonUrl);
					}
				}
			},

			// Fetch feed data from AjaxController
			_fetchFeedData: function(url) {
				$.ajax({
						url: url,
						dataType: 'json'
					})
					.done(
						Module._fetchFeedDataComplete
					)
					.fail(
						Module._fetchFeedDataError
					);
			},

			// Process feed data
			_fetchFeedDataComplete: function(data) {
				feedData = data;
				var hasResults = feedData.Listings.length >= 1;

				feedData.queryObj = queryObj;
				feedData.hasResults = hasResults;
				feedData.noResults = !hasResults;
				feedData.operatorMap = true;

				$.publish('/map/interactive/opened');
				$.publish('/operator/feed/loaded', [feedData]);
			},

			_fetchFeedDataError: function() {
				console.warn('There was an error retrieving operator data.');
			}
		};
	}
);
